import template from 'lodash/template';
import config from '../data/endpoints';
import axios from 'axios';
import storage from '../utilities/localStorage'
import { merge } from 'lodash';
import { env } from '../utilities/environment';
/**
 * Translation service
 * @type {{getTranslations(): *}}
 */
const defaultTranslations = {
  productName: 'Keno',
  future_bet: 'Future bet',
  random: 'Random bet',
  normal_bet: 'Normal bet',
  system_bet: 'System',
  random_system: 'Random system',
  results: 'Results',
  reset_betslip: 'Reset betslip',
  round: 'Round',
  starts_in: 'starts in',
  in_progress: 'in progress',
  betting_over: 'Betting time for previous round is over. Pay in ticket for next round?',
  max_system_number: 'Max number of system is {{ value }}',
  max_bet_number: 'Max number of bets is {{ value }}',
  max_future_rounds: 'Max number of future round is {{ value }}',
  max_amount_per_bet: 'Max amount per bet is {{ value }}',
  max_numbers: 'You have selected a maximum of numbers!',
  min_amount_per_bet: 'Min amount per bet is {{ value }}',
  min_amount_per_combination: 'Min amount per combination is {{ value }}',
  system_no_combinations: 'No system combinations available',
  empty_betslip_message: 'Pick your lucky numbers to',
  bet_not_valid: 'Bet not valid',
  select_bet: 'Select bet first',
  add_bet: 'Add',
  update_bet: 'Update',
  tab_betting: 'Betting',
  tab_special: 'Special bettings',
  select_random: 'Random',
  select_system: 'System',
  spot_hits: 'Hits',
  spot_odds: 'Odds',
};

export const TranslationSvc = {
  translationsLoaded: false,
  /**
   * Get translations
   * @returns {Promise}
   */
  getTranslations() {
    let translations = {};
    let kenoPromise;
    let shopPromise;

    const locale = sevenConfig.data.locale.iso1 || sevenConfig.data.company.language || sevenConfig.data.company.locale;
    const projectId = '6e97d48c5bc965124b963f94132aaed3';
    const tenantId = sevenConfig.data.tenant.uuid;

    const url = `${this.getFrasierEndpoint()}/${projectId}/locales/${locale.split('-')[0]}/tenants/${tenantId}?includeLocaleFallback=true`;

    kenoPromise = axios.get(url)
    .then(response => {
      translations = response.data;
    })
    if (sevenConfig.data.channel == 'Retail') {
      let shopUrl = `${config.gravityApi[env()]}shop/translations`;
      shopPromise = axios.get(shopUrl, {
        headers: {
          'X-Nsft-SCD-Locale': sevenConfig.data.locale.iso1 || sevenConfig.data.company.language || sevenConfig.data.company.locale,
        }
      })
      .then(response => {
        merge(translations, response.data);
      })
    }

    return Promise.all([kenoPromise, shopPromise]).then( () => {
      this._saveTranslations(translations);
    })
      .catch(error => {
        console.warning('Failed to load translations.', error);
      });
  },

  /**
   * Save translations to local storage
   * @param translations {object}
   * @private
   */
  _saveTranslations(translations) {
    storage.saveKey('translations', translations);
    this.translationsLoaded = true;
  },

  /**
   * Get translation
   * @param {string} key
   * @param {string|number} value
   * @returns {string}
   */
  getTranslation(key, value) {
    const storageTrans = storage.getKey('translations');

    let translation = storageTrans && storageTrans[key] ? storageTrans[key] :
      defaultTranslations[key] ? defaultTranslations[key] : key;

    if (value) {
      translation = translation.replace('{{ value }}', value);
    }

    return translation;
  },

    /**
   * Get frasier endpoint
   * @returns {string}
   */
  getFrasierEndpoint() {
    if (env() === 'staging') {
      return 'https://frasier.staging.de-2.nsoft.cloud/translations';
    }
    return 'https://frasier.de-2.nsoft.cloud/translations';
  }
};



// WEBPACK FOOTER //
// translation.service.js